import React from 'react';
import PropTypes from 'prop-types';

const specialTypes = ['delete', 'accept'];

const KeyboardButton = ({
    keyText,
    clickHandler,
    dataTestId,
    gtmAttribute,
}) => {
    const buttonText = specialTypes.includes(keyText) ? '' : keyText;

    return (
        <button
            className="fullslip__keyboard-button"
            onClick={clickHandler}
            data-test-id={dataTestId || null}
            data-spectate-product={gtmAttribute}
        >
            {buttonText}
        </button>
    );
};

KeyboardButton.propTypes = {
    keyText: PropTypes.string,
    clickHandler: PropTypes.func.isRequired,
    dataTestId: PropTypes.string,
    gtmAttribute: PropTypes.string,
};

KeyboardButton.defaultProps = {
    keyText: '',
    dataTestId: '',
    gtmAttribute: '',
};

export default KeyboardButton;
